import React, { useEffect, useState } from 'react';
import { Box, Typography, Dialog, DialogContent, Button, DialogActions  } from '@mui/material';
import Header from './Header';
import ContentSection from './Content';
import Footer from './Footer';
import { makeStyles } from '@mui/styles';

// const backgroundImage = 'https://s3-alpha-sig.figma.com/img/3c83/886f/4e64c8f3731c3f269e7c391031455d7d?Expires=1709510400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=cxaJ4HV31SZWA7TeOv-HCGUVM~436Loj5KrDgzsQKbRx9-XkoNpYktJvNj4UOB7klg4XQZgdcs9b1ukDcao3~AFd8zOY8hOtKdwkOSheOoMTFoBx8oc2govIWcoKcPniOXhQIGAnlT4rZ77suvo5fBIZIjeUWwl40iS5P8y4k08nhTRZU19Bn5cgYHeFdJx~kBmrZBdRoJHZRD5vFozzKTzPMhJq539A1yMwFn5rWT5e2uzF~FlYgrllUrDJlNAV0Xui6oMU47k0-odZeRdngoRsTWAYj6BfktDhRVS31ciZefckFQMRHwmgFE89npW9-wzoS-VtdkZw0QraG04KIw__';
const useStyles = makeStyles((theme) => ({
  info: {
    color: '#CC8500',
    fontSize: '14px',
    marginTop: '10px',
    marginLeft: '10px',
    textShadow: '.5px .5px #CC8500',
    animation: '$blinker 2s linear infinite'
  },
  '@keyframes blinker': {
    '50%': { opacity: 0 }
  }
}));
const LandingPage = ({ setApplicationFlow }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const containerStyle = {
    // backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '-80px'
  };
  useEffect(() => {
    setOpen(true);
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box component="div" sx={containerStyle}>
      <Header setApplicationFlow={setApplicationFlow} />
      <ContentSection />
      <Footer />
      {/* <Dialog open={open} onClose={handleClose}>
        <DialogContent>
          <Typography className={classes.info}>
            **Kindly visit Tutorial Video Section On TCP Website
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} style={{backgroundColor: '#9C6602', color: '#fff'}}>
            OK
          </Button>
        </DialogActions>
      </Dialog> */}
    </Box>
  );
};

export default LandingPage;
